import axios from 'axios';
import { BACKEND_INS_URL } from '../../../config/constants';
import regrasSLADefault from './regrasSLADefault';

// IDs das bases no backend InsightCare, exigidos pelo endpoint de regras de SLA.
const idsBase = {
  'db-orcl-hsl': 1,
  'db-orcl-hsln': 2,
  'db-orcl-hma': 3,
  'db-orcl-crb': 4,
  'db-orcl-crg': 5,
  'db-orcl-hsr': 6,
  'db-orcl-hcms': 8,
  'db-orcl-hslb': 9,
};

// Normaliza "Aguard. Atendimento" e "Aguardando Atendimento" para o mesmo valor.
const normalizarSituacaoAtendimento = (valor) => {
  if (typeof valor !== 'string') return valor;
  const chave = valor.trim().toLowerCase();
  return chave === 'aguard. atendimento' ? 'aguardando atendimento' : chave;
};

const normalizarCriterios = (criterios) => {
  if (criterios?.situacaoAtendimento == null) return criterios;
  return { ...criterios, situacaoAtendimento: normalizarSituacaoAtendimento(criterios.situacaoAtendimento) };
};

const normalizarRegrasProcessos = (processos) => {
  const processosNormalizados = {};
  for (const [tipoCard, processo] of Object.entries(processos)) {
    processosNormalizados[tipoCard] = {
      ...processo,
      Regras: (processo.Regras ?? []).map((regra) => ({
        ...regra,
        Criterios: normalizarCriterios(regra.Criterios)
      })),
    };
  }
  return processosNormalizados;
};

const regrasDefaultNormalizado = normalizarRegrasProcessos(regrasSLADefault);

let regrasAtivas = regrasDefaultNormalizado;

/**
 * Busca as regras de SLA na API e substitui as regras ativas.
 * Em caso de falha mantém as regras anteriores (ou o default).
 */
export const carregarRegrasSLA = async ({ base, company }) => {
  const idBase = idsBase[base];
  if (idBase == null || company == null) {
    return;
  }

  try {
    const url = BACKEND_INS_URL + '/command-center/regras-sla?sharedSecret=hd783g4kshd7f9fhalu&token=QYv6eY9v6w2WRVWzoyMCMJc3uuW3Z-79';
    const body = new URLSearchParams({ IDBase: idBase, CodigoEmpresa: company });
    const response = await axios.post(url, body);
    if (response.data?.Status && response.data?.ReturnData) {
      const processosValidos = Object.entries(response.data.ReturnData).filter(([, processo]) => Array.isArray(processo?.Regras));

      regrasAtivas = { ...regrasDefaultNormalizado, ...normalizarRegrasProcessos(Object.fromEntries(processosValidos)) };
    }
  } catch (error) {
    console.error('Falha ao carregar regras de SLA, mantendo regras anteriores.', error);
  }
};

/**
 * Determina a cor do SLA (VERDE/AMARELO/VERMELHO) de um card, comparando
 * seus dados com os critérios das regras ativas.
 */
export const buscarCorSLA = ({ tipoCard, tempo, classificacaoRisco, tipoExame, situacaoAtendimento, situacaoMedicacao, tipoPaciente, tipoExameLaboratorial }) => {
  const corDefault = 'VERDE';

  const valoresCard = {
    situacaoAtendimento: normalizarSituacaoAtendimento(situacaoAtendimento),
    tipoPaciente,
    classificacaoRisco: classificacaoRisco ?? 'VERDE',
    situacaoMedicacao,
    tipoExameLaboratorial,
    tipoExame,
  };

  const processo = regrasAtivas?.[tipoCard];
  if (!processo) {
    return corDefault;
  }

  const regra = (processo.Regras ?? []).find(({ Criterios }) =>
    Object.entries(Criterios ?? {}).every(([chave, valor]) =>
      valoresCard[chave] == null || valoresCard[chave] === valor
    )
  );

  const limite = regra?.Limite ?? processo.Limite;
  if (!limite) {
    return corDefault;
  }

  if (limite.verde != null && tempo < limite.verde) {
    return 'VERDE';
  }
  if (limite.amarelo != null && tempo < limite.amarelo) {
    return 'AMARELO';
  }
  return 'VERMELHO';
};
